import React, {FC} from 'react'
import {Routes, Route, Navigate} from 'react-router-dom'
import {PageTitle} from '_metronic/layout/core'
import OrderList from './list/OrderList'
import FulfillmentPage from './fulfillments/FulfillmentPage'
import OrderEditPage from './orderEdit/OrderEditPage'
import {FeatureFlagProvider} from '../context/FeatureFlagContext'

const OrdersPage: FC = () => {
  return (
    <React.Suspense fallback='Loading'>
      <Routes>
        <Route
          index
          element={
            <>
              <PageTitle breadcrumbs={[]}>Orders</PageTitle>
              <OrderList />
            </>
          }
        />
        <Route path=':orderId' element={<Navigate to='fulfillments/view' />} />
        <Route
          path=':orderId/fulfillments/*'
          element={
            <FeatureFlagProvider>
              <FulfillmentPage />
            </FeatureFlagProvider>
          }
        />
        <Route
          path=':orderId/*'
          element={
            <FeatureFlagProvider>
              <OrderEditPage />
            </FeatureFlagProvider>
          }
        />
      </Routes>
    </React.Suspense>
  )
}

export default OrdersPage
